import { apiClient } from './client';

export interface SetupStep {
  complete: boolean;
  count: number;
  testedCount?: number;
  description: string;
}

export interface SetupCompleteness {
  steps: {
    systems: SetupStep;
    connections: SetupStep;
    entities: SetupStep;
    schemas: SetupStep;
    mappings: SetupStep;
  };
  completedCount: number;
  totalSteps: number;
  setupComplete: boolean;
}

export async function getSetupCompleteness(): Promise<SetupCompleteness> {
  return apiClient.get('/api/setup/completeness');
}
